import React, { useState } from "react";
import EntryColor from "../container/EntryColor";
import FlatViewExacta from "./FlatViewExacta";
import ModalOpenBetsChart from "../modals/ModalOpenBetsChart";
import SwitchActiveBetsColum from "../utilities/SwitchActiveBetsColum";
import ButtonOpenBetsBetType from "../utilities/ButtonOpenBetsBetType";
import { MDBTooltip } from "mdb-react-ui-kit";

const Exacta = ({
  entries,
  charts,
  otherViews,
  getOpenBetsChartModal,
  openBetsChartInfo,
  setOpenBetsChartInfo,
  userInfo,
  idExacta,
  raceID,
  voidTickets,
  callTicketVoidListFrom,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
  setSelectionsSelected,
  getCharts,
}) => {
  var totalEntries = entries.length + 1;
  const [showBetsColumnExacta, setShowBetsColumnExacta] = useState(false);
  var exactaArray = new Array(totalEntries);

  //Bucle para meter en cada posición otros array de 10
  for (var i = 0; i < totalEntries; i++) {
    exactaArray[i] = new Array(totalEntries);
  }

  entries.forEach((entry, k) => {
    exactaArray[0][k + 1] = entry.EntryNum;
    exactaArray[k + 1][0] = entry.EntryNum;
  });

  charts.forEach((chart, i) => {
    let selections = chart.Selections.split(",");
    exactaArray[selections[0]][selections[1]] = String(
      chart.Amount + "," + chart.BetCount
    );
  });

  //Recorrer chart y sacar los selection con split y meterlos en new array
  var tableContent = [],
    headers = [],
    tdExacta = [],
    tdFirstLeg = [];

  for (let i = 0; i < exactaArray.length; i++) {
    //columnas
    for (let j = 0; j < exactaArray[i].length; j++) {
      //filas
      let colorHeader;

      if (i === 0) {
        let colspan;
        if (i === 0 && j !== 0) {
          colspan = 2;
          colorHeader = "#00334d";
        }
        headers.push(
          <th
            colSpan={showBetsColumnExacta ? colspan : 1}
            style={{
              verticalAlign: "middle",
              backgroundColor: colorHeader,
            }}
            key={j}
          >
            <EntryColor
              entryNum={exactaArray[i][j]}
              saddleNum={exactaArray[i][j]}
              finishPos={
                exactaArray[i][j] !== undefined
                  ? entries[exactaArray[i][j] - 1].FinishPos
                  : null
              }
            />
          </th>
        );
      }

      if (j !== 0 && i !== 0) {
        //This variable (selections) is used as a parameter to query getOpenBetsChart
        let selections = i + "," + j.toString();

        let amount = exactaArray[i][j];
        if (amount) {
          let values = amount.split(",");
          tdExacta.push(
            <React.Fragment key={j}>
              <td
                style={{ verticalAlign: "middle", fontWeight: "bold" }}
                key={"amount" + j}
              >
                <MDBTooltip
                  tag="span"
                  wrapperProps={{ href: "#" }}
                  title="Money"
                >
                  ${parseFloat(values[0]).toFixed(2)}
                </MDBTooltip>
              </td>
              {showBetsColumnExacta && (
                <td
                  style={{ verticalAlign: "middle" }}
                  key={"cantBets" + j}
                  className="cantBets"
                  data-toggle="modal"
                  data-target="#openBetsChartModal"
                  onClick={() => {
                    getOpenBetsChartModal(idExacta, selections);
                    setSelectionsSelected(selections);
                  }}
                >
                  <MDBTooltip
                    tag="span"
                    wrapperProps={{ href: "#" }}
                    title="# Bets"
                  >
                    {values[1]}
                  </MDBTooltip>
                </td>
              )}
            </React.Fragment>
          );
        } else if (j === i) {
          tdExacta.push(
            <td
              colSpan={showBetsColumnExacta ? 2 : 1}
              style={{ backgroundColor: "#dee2e6" }}
              key={j}
            ></td>
          );
        } else {
          tdExacta.push(
            <td
              colSpan={showBetsColumnExacta ? 2 : 1}
              style={{ verticalAlign: "middle" }}
              key={j}
            ></td>
          );
        }
      }

      if (j === 0 && i !== 0) {
        tdFirstLeg.push(
          <td key={j} className="firstLegTD">
            {
              <EntryColor
                entryNum={exactaArray[i][j]}
                saddleNum={exactaArray[i][j]}
                finishPos={
                  exactaArray[i][j] !== undefined
                    ? entries[exactaArray[i][j] - 1].FinishPos
                    : null
                }
              />
            }
          </td>
        );
      }
    }
    tableContent.push(
      <tr key={i}>
        {tdFirstLeg}
        {tdExacta}
      </tr>
    );

    tdExacta = [];
    tdFirstLeg = [];
  }

  return (
    <>
      <ModalOpenBetsChart
        openBetsChartInfo={openBetsChartInfo}
        setOpenBetsChartInfo={setOpenBetsChartInfo}
        userInfo={userInfo}
        wagerTypeId={idExacta}
        voidTickets={voidTickets}
        callTicketVoidListFrom={callTicketVoidListFrom}
        selectedTicketsVoidScore={selectedTicketsVoidScore}
        setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
        selectAllTickets={selectAllTickets}
        setSelectAllTickets={setSelectAllTickets}
        scoreTickets={scoreTickets}
        setCallTicketVoidListFrom={setCallTicketVoidListFrom}
        getCharts={getCharts}
      />
      <div className="row">
        <div className="col-sm-6">
          <SwitchActiveBetsColum
            showBetsColumn={showBetsColumnExacta}
            setShowBetsColumn={setShowBetsColumnExacta}
          />
        </div>
        <div className="col-sm-6" style={{ textAlign: "right" }}>
          <ButtonOpenBetsBetType
            ticketType={idExacta}
            raceID={raceID}
            userInfo={userInfo}
            openBetsChartInfo={openBetsChartInfo}
            setOpenBetsChartInfo={setOpenBetsChartInfo}
          />
        </div>
      </div>

      {!otherViews ? (
        <>
          <div className="mb-2" style={{ textAlign: "right" }}>
            <span
              className="badge rounded-circle"
              style={{ backgroundColor: "#79a6d2", color: "transparent" }}
            >
              ..
            </span>
            <span className="mr-3 ml-1">First Leg</span>
            <span
              className="badge rounded-circle"
              style={{ backgroundColor: "#00334d", color: "transparent" }}
            >
              ..
            </span>
            <span className="ml-1">Second Leg</span>
          </div>
          <div className="scrollHorizontal">
            <table className="table table-bordered table-sm">
              <thead className="theadFixed">
                <tr className="text-center">{headers}</tr>
              </thead>
              <tbody className="table-sm text-center table-bordered">
                {tableContent}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <FlatViewExacta
          charts={charts}
          getOpenBetsChartModal={getOpenBetsChartModal}
          idExacta={idExacta}
          showBetsColumnExacta={showBetsColumnExacta}
          setSelectionsSelected={setSelectionsSelected}
        />
      )}
    </>
  );
};

export default Exacta;
